import { Injectable } from "@angular/core";
import { ConfUIItem, CodeDisplayStyles, CodePanel, Form, PageLocation } from "../../../models";
import { SummaryDisplayStyles } from "../../../../configurator/summary/prices/SummaryDisplayStyle";
import * as Immutable from "immutable";
import { ProductDataStore } from "../../../providers/productData";
import { ConfPageSessionService } from "../../../../configurator/providers";

@Injectable()
export class FormValueModelBuilder {

  constructor(
    public productStore: ProductDataStore) {
  }

  /**
   * Returns the list of values for each panel.   
   * Note!  if <confUIItem> is the instance of <GroupConfUIItem> then list must contain the multiple panels models.
   * @param confUIItem
   * @param isEditor
   * @param filterDisplayStyles
   */
  public build(confUIItem: ConfUIItem, isPanel: boolean): Form {

    let panel = this.productStore.getEntity<Form>(confUIItem.id);

    const displayStyle = panel.pageLocation as PageLocation;

    if (!isPanel && displayStyle == PageLocation.SummaryNewActionPanel)
      return panel;

    return null;
  }

  addForm(forms: Array<Form>, x: ConfUIItem) {
    const visualObject = this.productStore.getEntity(x.id);
    if (visualObject instanceof Form) {
      forms.push(visualObject);
    }
  }

}